import _ from 'lodash';
import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState'

/**
 * 
 * @param {Estado} state 
 * @param {Ação} action 
 */
const balancaReducer = (state = InitialState.balancaReducer, action) => {
    switch (action.type) {
        case ActionType.GET_BALANCA_RESPONSE: {
            return {
                ...state,
                balancaObject: _.assign(action.balancaObject),
                error: _.assign(action.error)
            }
        }
        default: { return state; }
    }
}

export default balancaReducer;